<template>
    <div class='alerts-list'>
      <div
        v-for="(alert, index) in alerts"
        :key="index"
        class='row between container alert-item'
        @click.stop="() => alert.route && handleItemClick(alert.route)"
        :class="{
            dismissed: alert.dismissed,
            neutral: alert.status && alert.status === 'neutral',
            bad: alert.status && alert.status === 'bad',
            good: alert.status && alert.status === 'good'
        }"
    >
        {{ alert.message }}
        <button @click.stop="() => handleDismissItem(alert, index)">
            dismiss
        </button>
      </div>
    </div>
</template>

<script>
import router from '../router'
export default {
  name: "alerts-list",
  components: {},
  methods: {
      handleItemClick (route) {
        router.push(`/${route}`)
    },
    handleDismissItem (alert, index) {
        const updatedItem = { ...alert, dismissed: true}
        let updatedAlerts = [...this.alerts]
        updatedAlerts[index] = updatedItem
        this.$store.commit('updateAlertsList', updatedAlerts)
    }
  },
  computed: {
    alerts() {
      return [...this.$store.getters.alerts]
    },
  }
};
</script>

<style scoped lang='scss'>
@import '../styles/colors.scss';
.alerts-list {
    padding-top: 2px;
    .alert-item {
        height: 40px;
        margin-top: 8px;
        align-items: center;
        border-radius: 4px;
        color: rgb(102, 102, 102);
        background-color: rgb(238, 238, 238);
        padding-left: 10px;
        width: calc(96% - 10px);
        box-shadow: 0 0 2px rgb(201, 201, 201);
        transition: all .3s;
        overflow: hidden;
        &.neutral { 
            border-left: 6px solid tan;
         }
        &.good { 
            border-left: 6px solid $green;
         }
        &.bad { 
            border-left: 6px solid $red;
         }
         button {
             font-size: .9rem;
             background: none;
             padding-right: 10px;
             padding-left: 10px;
             color: $red;
         }
        &:hover {
            background-color: rgb(163, 163, 163);
            color: #fff;
            cursor: pointer;
            & button {
                color: #fff;
            }
        }
        &.dismissed {
            margin: 0 auto;
            padding: 0;
            height: 0;
            width: 96%;
        }
    }
}
</style>